<template>
  <ion-page :class="`${isDense ? 'dense' : ''}`">
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ setTitle }}</ion-title>
        <ion-back-button slot="start" text="Lista" color="medium" @click="backButton()"/>
        <!-- <ion-buttons slot="start">
          <ion-button @click="backButton()">
            <ion-icon :icon="arrowBack"></ion-icon>
          </ion-button>
        </ion-buttons> -->
      </ion-toolbar>
      <ion-toolbar>
        <ion-segment :value="segment" @ionChange="changeSegment($event)" ref="myIonSegment">
          <ion-segment-button value="data" :style="{padding: '0 5px'}">
            <ion-label>{{ titleDataSegment }}</ion-label>
          </ion-segment-button>
          <ion-segment-button value="items" v-if="typeDetails !== 'none'" :style="{padding: '0 5px'}">
            <ion-label>Itens</ion-label>
          </ion-segment-button>
          <ion-segment-button value="taxes" v-if="computedShowTaxes" :style="{padding: '0 5px'}">
            <ion-label>Impostos</ion-label>
          </ion-segment-button>
          <ion-segment-button v-if="this.bills && this.bills.active" value="bills" :class="{ 'due-date-exists': dueDateExists, 'due-date-not-exists': !dueDateExists && (computedItemsBills && computedItemsBills.length > 0) }" :style="{padding: '0 5px'}">
            <ion-label>
              <!-- <ion-icon v-if="dueDateExists" :icon="alertOutline"  color="danger" size="small"></ion-icon> -->
              Títulos 
            </ion-label>
          </ion-segment-button>
          <ion-segment-button v-if="this.purchases && this.purchases.active" value="purchases" :style="{padding: '0 5px'}">
            <ion-label>
              Compras 
            </ion-label>
          </ion-segment-button>
          <ion-segment-button v-if="this.ordersByCustomer && this.ordersByCustomer.active" value="ordersByCustomer" :style="{padding: '0 5px'}">
            <ion-label>
              Pedidos 
            </ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </ion-header>
    <keep-alive>
      <ion-content :style="{opacity: showFooter ? .25 : 1}" :key="this.$route.params.id || keyRegister" v-if="this.$route.params.id || keyRegister">
        <ion-content name="bills" v-show="segment === 'bills'">
          <Bills
            v-if="bills && bills.active"
            :headers="computedHeadersBills"
            :items="computedItemsBills"
            :client="item.SA1 || item"
            :color="color" 
            :props="props" 
            :customActions="this.bills.customActions"
            :dueDateField="computedDueDateField"
          />
        </ion-content>
        <ion-content name="purchases" v-show="segment === 'purchases'">
          <Purchases
            v-if="purchases && purchases.active"
            :headers="purchases.headers"
            :items="itemsPurchases"
            :client="item.SA1 || item"
            :color="color" 
            :props="props" 
            :dueDateField="computedDueDateField"
          />
        </ion-content>
        <ion-content name="ordersByCustomer" v-show="segment === 'ordersByCustomer'">
          <OrdersByCustomer
            v-if="ordersByCustomer && ordersByCustomer.active"
            :headers="ordersByCustomer.headers"
            :items="itemsOrdersByCustomer"
            :client="item.SA1 || item"
            :props="props" 
            :color="color"
          />
        </ion-content>
        <ion-content name="data" v-show="segment === 'data'">
          <ion-card v-if="item.errorErp" class="card-errors" color="danger">
            <ion-card-header>
              <ion-button :color="'danger'" 
                @click="showErrors = !showErrors"
                expand="full">
                <ion-icon :icon="alertCircleOutline"></ion-icon> | Ver Erros do Erp
              </ion-button>
            </ion-card-header>
            <ion-card-content v-if="showErrors">
              <h1>Erros do ERP</h1>
              {{item.errorErp}}
            </ion-card-content>
          </ion-card>
          <FormMV2
            v-if="props.mobileV2"
            :inputs="computedInputsMaster"
            :props="props"
            :collection="collection"
            :model="item"
            :color="color"
            :collectionDetails="collectionDetails"
            :readonly="readonlyComputed"
            @changeForm="changeForm"
            @submit="submit()"
            ref="formMaster"
          />
          <Form
            v-else
            :inputs="computedInputsMaster"
            :collection="collection"
            :model="item"
            :color="color"
            :collectionDetails="collectionDetails"
            :readonly="readonlyComputed"
            @changeForm="changeForm"
            @submit="submit()"
            ref="formMaster"
          />
  
          <div :style="{ height: '60px' }" />
        </ion-content>
        <ion-content name="items" v-show="segment === 'items'">
          <FormDataTableV2MV2
            v-if="props.mobileV2 && onDemand && !offline"
            :props="props"
            :headers="computedHeaders"
            :tableIdForeignValue="tableIdForeignValue"
            :itemsDetails="itemsDetails"
            :filters="computedFilters"
            :xlsxName="xlsxName"
            :color="color"
            :readonly="readonlyComputed"
            :filterItems="filterItemsFunction"
            :inputsMaster="computedInputsMaster"
            :formMaster="computedItemFormMaster"
            @setTotalize="(event) => totalize = event"
            :user="user"
            :userRules="userRules"
            :searchAsyncItems="computedSearchAsyncItems"
            :companySelected="companySelected"
            ref="formDetails"
          />

          <FormDataTableV2
            v-else-if="onDemand && !offline"
            :props="props"
            :headers="computedHeaders"
            :tableIdForeignValue="tableIdForeignValue"
            :itemsDetails="itemsDetails"
            :filters="computedFilters"
            :xlsxName="xlsxName"
            :color="color"
            :readonly="readonlyComputed"
            :filterItems="filterItemsFunction"
            :formMaster="computedItemFormMaster"
            @setTotalize="(event) => totalize = event"
            ref="formDetails"
          />

          <FormDataTableMV2
            v-else-if="props.mobileV2"
            :headers="computedHeaders"
            :props="props"
            :items="inputsDetails"
            :filters="computedFilters"
            :xlsxName="xlsxName"
            :color="color"
            :readonly="readonlyComputed"
            :filterItems="filterItemsFunction"
            :formMaster="computedItemFormMaster"
            :user="user"
            :userRules="userRules"
            :tableSA7="tableSA7"
            :emptyResItems="emptyResItems"
            :SA7off="computedSA7off"
            @filterSA7="filterSA7"
            @setTotalize="(event) => totalize = event"
            ref="formDetails"
          />
        
          <FormDataTable
            v-else
            :headers="computedHeaders"
            :items="inputsDetails"
            :filters="computedFilters"
            :xlsxName="xlsxName"
            :color="color"
            :readonly="readonlyComputed"
            :filterItems="filterItemsFunction"
            :formMaster="computedItemFormMaster"
            @setTotalize="(event) => totalize = event"
            ref="formDetails"
          />
         
          <div :style="{ height: '60px' }" />
        </ion-content>
        <ion-content name="taxes" v-if="computedShowTaxes" v-show="segment === 'taxes'">
          <!-- IMPOSTOS -->
          <ion-card class="card-taxes">
            <ion-card-header v-if="!item.bloqueado">
              <ion-button
                size="small" 
                expand="full"
                fill="outline"
                @click="calcImps()"
                :disabled="impostos.loading"
              >
                {{impostos.loading ? impostosMessage : 'Calcular Impostos'}}
              </ion-button>
              <ion-progress-bar type="indeterminate" v-if="impostos.loading"></ion-progress-bar>
            </ion-card-header>
            <ion-card-content v-if="impostos && impostos.headers && impostos.headers.length > 0">
              <ion-list>
                <ion-item
                  v-for="(header, index) in impostos.headers"
                  :key="index"
                >
                  <ion-label position="floating">{{ header.text }}</ion-label>
                  <ion-input
                    :value="
                      'R$ ' +
                      impostos.itens[0][header.value].toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    "
                    disabled
                  />
                </ion-item>
              </ion-list>
            </ion-card-content>
          </ion-card>
        </ion-content>
        <ion-fab
          horizontal="end"
          vertical="bottom"
          ref="ionFab"
        >
          <!-- v-if="!readonlyComputed && computedClaims.add" -->
          <ion-fab-button>
            <ion-icon :icon="ellipsisVertical" />
          </ion-fab-button>
          <ion-fab-list side="top">
            <div
              :style="{
                position: 'absolute',
                right: '6px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }"
            >
              <ion-button
                v-if="companySelected.groupCompany == 'decanter'"
                shape="round" 
                fill="solid"
                color="warning"
                @click="ultPedido();closeFab()">
                <ion-icon :icon="downloadOutline"/>
                Último pedido
              </ion-button>
              <ion-button fill="solid" shape="round" 
                color="tertiary"
                @click="generatePdf({});closeFab()" 
                v-if="computedExportPdf">
                <ion-icon :icon="documentOutline"/>
                <ion-label :style="{fontSize: '0.9em', marginLeft: '8px'}">
                  Exportar PDF
                </ion-label>
              </ion-button>
              <template v-for="(cAction, index) of computedCustomActions" :key="index">
                <ion-button  
                  fill="solid" 
                  shape="round"
                  v-show="showAction({item, customAction: cAction})" 
                  @click="clickAction({item, customAction: cAction});closeFab()" 
                >
                  <ion-icon :icon="convertIcon(cAction.icon)"/>
                  <ion-label :style="{fontSize: '0.9em', marginLeft: '8px'}">{{cAction.name}}</ion-label>
                </ion-button>
              </template >
              <ion-button
                v-if="!readonlyComputed && computedClaims.sync"
                expand="block"
                fill="solid"
                shape="round"
                color="success"
                @click="submit();closeFab()"
              >
                <ion-icon :icon="saveOutline" />
                <ion-label v-if="offline" :style="{ fontSize: '0.9em', marginLeft: '8px' }">Gravar Offline</ion-label>
                <ion-label v-else :style="{ fontSize: '0.9em', marginLeft: '8px' }">{{(props.labelButtonDraft) ? props.labelButtonDraft : 'Gravar Rascunho'}}</ion-label>
              </ion-button>
              <ion-button fill="solid" shape="round" 
                @click="submit({submitToErp: true});closeFab()" 
                v-if="!readonlyComputed && computedClaims.sync && !offline">
                <ion-icon :icon="exitOutline"/>
                <ion-label :style="{fontSize: '0.9em', marginLeft: '8px'}"> {{(props.labelButtonSend) ? props.labelButtonSend : 'Gravar para Envio'}}</ion-label>
              </ion-button>
            </div>
          </ion-fab-list>
        </ion-fab>
      </ion-content>
    </keep-alive>
    <ion-footer v-if="collectionDetails && ['data', 'items', 'taxes'].includes(segment)" class="ion-no-padding ion-no-margin ion-footer-totalize" style="background-color: transparent">
      <ion-card class="ion-no-padding" :style="{ margin: '2px'}">
        <ion-card-header @click="showFooter = !showFooter" class="ion-no-padding ion-no-margin" :style="{ padding: '8px' }">
          <ion-grid class="ion-no-padding">
            <ion-row class="row-margin-bottom ion-text-center">
              <b class="ion-text-center" style="width: 100%">
                Totais  
              </b>              
            </ion-row>
            <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
           
            <!-- Loading -->
            <ion-row v-if="!totalize" class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
              <ion-col size="12">
                <ion-spinner name="dots"></ion-spinner>
              </ion-col>
            </ion-row>
            <ion-row  v-else-if="!showFooter && totalize" class="ion-justify-content-between">
              <ion-col v-for="(total, index) of totalize.filter(ct => ct.mobile)" :key="index" style="font-size: 1em">
                <ion-row class="ion-justify-content-center">
                  <small>{{ total.label/*.substr(0,15)*/ }}</small>
                </ion-row>
                <ion-row class="ion-justify-content-center">
                  {{ total.text }} 
                </ion-row>
              </ion-col>
            </ion-row>
            <ion-row v-else-if="showFooter">
              <ion-list>
                <ion-item lines="full" v-for="(total, index) of totalize" :key="index">
                  <ion-label>{{ total.label }}</ion-label>                  
                  <ion-input
                    class="ion-text-end"
                    :disabled="true"
                    :value="total.text"
                  />
                </ion-item>
              </ion-list>
            </ion-row>
          </ion-grid>
        </ion-card-header>
      </ion-card>
    </ion-footer>
  </ion-page>
</template>

<script>
  import store from "../../store";
  import Form from "@/components/Registers/Form";
  import FormMV2 from "@/components/Registers/FormMV2";
  import FormDataTable from "@/components/FormDataTable.vue";
  import FormDataTableV2 from "@/components/FormDataTableV2.vue";
  import FormDataTableV2MV2 from "@/components/FormDataTableV2MV2.vue";
  import FormDataTableMV2 from "@/components/FormDataTableMV2.vue";
  import Bills from "@/components/Bills.vue"
  import Purchases from "@/components/Purchases.vue"
  import OrdersByCustomer from "@/components/OrdersByCustomer"
  import {
    createNamespacedHelpers,
    mapActions,
    mapMutations,
    mapState,
  } from "vuex";
  import {
    arrowBack,
    ellipsisVertical,
    checkmark,
    search,
    saveOutline,
    exitOutline,
    documentOutline,
    downloadOutline,
    add,
    alertOutline,
    newspaperOutline,
    alertCircleOutline
  } from "ionicons/icons";
  import {
    IonFab,
    IonContent,
    IonPage,
    IonFabList,
    IonToolbar,
    IonProgressBar,
    IonButton,
    IonHeader,
    IonTitle,
    IonIcon,
    IonLabel,
    IonSpinner,
    IonCol,
    IonFabButton,
    IonSegment,
    IonSegmentButton,
    IonCard,
    IonGrid,
    IonRow,
    IonCardContent,
    IonCardHeader,
    IonItem,
    IonList,
    IonInput,
    IonFooter,
    IonBackButton
  } from "@ionic/vue";
  const {
    mapState: registersState,
    mapActions: registersActions,
    mapMutations: registersMutations,
  } = createNamespacedHelpers("registers");
  const { mapState: authState } = createNamespacedHelpers("auth");
  import { jsPDF } from "jspdf";
  import "jspdf-autotable";
  import * as fs from "file-saver";
  import axios from "axios";
  export default {
    name: "Register",
    setup() {
      return {
        arrowBack,
        ellipsisVertical,
        checkmark,
        search,
        saveOutline,
        exitOutline,
        documentOutline,
        downloadOutline,
        add,
        alertOutline,
        newspaperOutline,
        alertCircleOutline
      };
    },
    components: {
      Bills,
      Purchases,
      OrdersByCustomer,
      Form,
      FormMV2,
      FormDataTable,
      FormDataTableV2,
      FormDataTableV2MV2,
      FormDataTableMV2,
      IonFab,
      IonContent,
      IonSpinner,
      IonCol,
      IonPage,
      IonFabList,
      IonToolbar,
      IonButton,
      IonHeader,
      IonTitle,
      IonIcon,
      IonLabel,
      IonFabButton,
      IonSegment,
      IonSegmentButton,
      IonCard,
      IonProgressBar,
      IonCardContent,
      IonCardHeader,
      IonItem,
      IonGrid,
      IonRow,
      IonList,
      IonFooter,
      IonInput,
      IonBackButton
    },
    props: {
      props: {
        type: Object,
        default: () => {}
      },
      name: {
        type: String,
        required: false,
      },
      collection: {
        type: String,
        required: true,
      },
      register: {
        type: String,
        required: true,
      },
      externalRequest: Object,
      inputsMaster: {
        type: Array,
        default: () => [],
      },
      blockedField: String,
      color: {
        required: false,
        type: String,
        default: "indigo",
      },
      readonly: {
        required: false,
        type: Boolean,
        default: () => false,
      },
      edit: {
        required: false,
        type: Boolean,
        default: () => false,
      },
      integration: {
        required: false,
        type: Boolean,
        default: () => false,
      },
      dispatch: {
        type: Array,
        default: () => [],
      },
      collectionDetails: {
        required: false,
        type: String,
      },
      headersDetails: {
        type: Array,
        default: () => [],
      },
      tableCollection: {
        type: String,
        default: "",
      },
      tableSubcollection: {
        type: String,
        default: "",
      },
      orderSubcollection: {
        required: false,
      },
      tableIdFrom: {
        type: String,
        default: "",
      },
      tableSA7: {
        type: Boolean,
        default: false
      },
      onDemand: {
        type: Boolean,
        default: false
      },
      tableIdForeign: {
        type: String,
        default: ""
      },
      querySubcollection: {
        type: String,
        default: ""
      },
      fieldsReturn: {
        type: String,
        default: ""
      },
      filtersDetails: {
        type: Array,
        default: () => [],
      },
      filterItems: String,
      xlsxName: String,
      typeDetails: String,
      impostosPdfText: String,
      totaisPdfText: String,
      colorPdfTable: String,
      titleOfPrint: String,
      printCompanyHeaders: {
        type: Array,
        default: () => []
      },
      claims: {
        type: Object,
        required: true,
        default: () => ({
          add: false, 
          view: false, 
          edit: false, 
          delete: false, 
          copy: false, 
          sync: false
        }),
      },
      exportPdf: {
        type: Boolean,
        required: false,
        default: true,
      },
      customActions: {
        type: Array,
        default: () => [],
      },
      taxCalculation: Object,
      bills: Object,
      purchases: Object,
      ordersByCustomer: Object,
      printLayout: {
        active: Boolean,
        link: String
      }
    },

    data() {
      return {
        recorded: false,
        leave: false,
        keyRegister: 0,
        segment: "data",
        headerTitle: "",
        ready: false,
        showErrors: false,
        item: {},
        itemsDetails: [],
        tableItems: [],
        emptyResItems: false,
        tableIdForeignValue: null,
        autoSave: {
          saveTime: 1000 * 60 * 2,
          timer: null,
          id: null
        },
        impostos: {
          headers: [],
          itens: [],
          noDataDefault: "Não há dados disponíveis",
          noData: "Não há dados disponíveis",
          loading: false,
        },
        printSketch: {
          headers: [],
          itens: [],
          noDataDefault: 'Não há dados disponíveis',
          noData: 'Não há dados disponíveis',
          loading: false,
        },
        jsPdf: {
          doc: null,
          dialog: false,
          sendEmail: {
            sending: false,
            dialog: false,
            inputs: [
              { type: "text-field", value: "to", label: "Email de Destino" },
              { type: "text-field", value: "cc", label: "Cc", md: 6 },
              { type: "text-field", value: "bcc", label: "Cco", md: 6 },
              { type: "text-field", value: "subject", label: "Assunto" },
              {
                type: "textarea",
                value: "text",
                label: "Corpo do Email",
                rows: 4,
              },
            ],
            model: null,
          },
          blob: null,
        },
        tableIdFromValue: null,
        itemFormMaster: {},
        itemsBills: null,
        fieldGetBillsValue: "",
        itemsPurchases: null,
        fieldGetPurchasesValue: "",
        itemsOrdersByCustomer: null,
        fieldGetOrdersByCustomerValue: "",
        totalize: [],
        showFooter: false,
        dueDateExists: false,
        disableSA7: false,
        SA7off: false,
      };
    },

    computed: {
      ...registersState(["registers"]),
      ...mapState(["companies", "offline", "companySelected"]),
      ...authState(["user"]),
      computedShowTaxes() {
        return this.taxCalculation && this.taxCalculation.active && ['cermag'].includes(this.companySelected.groupCompany)
      },

      isDense() { return this.props.formDense },

      computedSearchAsyncItems () {
        return ['ore'].includes(this.companySelected.groupCompany)
      },

      titleDataSegment() { 
        let title = 'Cabeçalho'
        switch (this.collection) {
          case 'SA1':
            title = 'Cliente'
            break;
          case 'SC5':
            title = 'Pedido'
            break;
        }
        return title
      },
      userRules() {
        if (this.user.superAdmin) {
          return this.computedUserRules
        } else if (!this.user.companies) {
          return []
        }
        return this.computedUserRules.filter(ur => 
          this.user.companies &&
          this.user.companies[this.companySelected.groupCompany] &&
          this.user.companies[this.companySelected.groupCompany]['rules'] && 
          this.user.companies[this.companySelected.groupCompany]['rules'].includes(ur.id)
        )
      },

      computedUserRules () {
        return this.registers['userRules']
      },

      // validatedDetails() {
      //   // Integração não cadastra items
      //   if (!this.typeDetails || this.typeDetails === "none") {
      //     return true
      //   }
      //   // Items não carregados
      //   else if (!this.inputsDetails || !this.inputsDetails.length > 0 || !this.filterItemsFunction) {
      //     return false
      //   } 
      //   // Verifica se items foram preenchidos
      //   else {
      //     return !(this.inputsDetails.filter(i => i.invalidItem).length > 0) && this.inputsDetails.filter(this.filterItemsFunction).length > 0
      //   }
      // },

      setTitle() {
        return store.$router.currentRoute.value.name;
      },

      computedDueDateExists() {
        return this.dueDateExists
      },

      computedItemFormMaster() {
        return this.itemFormMaster
      },

      readonlyComputed() {
        const readOnly = (
          this.readonly 
          || 
          (
            this.item && this.blockedField
            ? this.item[this.blockedField]
            : false
          )
        )
        
        return readOnly;
      },

      computedXlsName() {
        const xlsNameComputed = this.xlsxName.includes('=>') ? eval(this.xlsxName)({item: this.item}) : this.xlsxName
        return xlsNameComputed.trim()
      },

      computedInputsMaster() {
        return this.inputsMaster.map((i) => {
          const input = { ...i };

          if (input.set) input.set = eval(input.set);

          if (input.computed) input.computed = eval(input.computed);

          if (typeof input.itemText == "string" && input.itemText.includes("=>"))
            input.itemText = eval(input.itemText);

          if (typeof input.items == "string" && input.items.includes("=>"))
            input.items = eval(input.items);

          if (input.type === "select") {
            if (
              input.compareWith &&
              typeof input.compareWith == "string" &&
              (input.compareWith.includes("=>") ||
                input.compareWith.includes("function"))
            ) {
              input.compareWith = eval(input.compareWith);
            } else {
              input.compareWith = (o1, o2) => {
                return o1.value === o2.value;
              };
            }
          }

          if (input.model) input.model = eval(input.model);

          if (input.markers) {
            input.markers = Object.entries(input.markers).reduce(
              (acc, [key, val]) => ({
                ...acc,
                [key.trim().toLocaleLowerCase()]: val,
              }),
              {}
            );

            input.markers = {...input.markers, offline: 'offline' }
          }

          // envia todos os campos caso esteja cadastrando
          if (!this.id) input.send = true;

          if (typeof input.hide == "string" && input.hide.includes("=>"))
            input.hide = eval(input.hide);
        
          if (typeof input.disabled == 'string' && input.disabled.includes('=>')) {
            try{
              if(input.disabled){
                input.disabled = eval(input.disabled)
              }
            } catch (e){
              console.error(e)
              input.disabled = false
            }
          }

          if (input.filterRegister) {
            if (!input.on) input.on = {}
            if (!input.on.change) input.on.change = []

            const arrFilter = Array.isArray(input.filterRegister) ? input.filterRegister : [input.filterRegister]
            // arrFilter.forEach(arr => {
            for (const arr of arrFilter ) {
              const filter = eval(arr.filter)
              if (this.registers[arr.register]) {
                input.on.change.push(
                  (value) => {
                    const formMaster = this.$refs.formMaster ? this.$refs.formMaster.getModel() : {}
                    const ret = filter({register: store.$_.cloneDeep(this.registers[arr.register]), value, item: formMaster })
                    this.registers[`${arr.register}Filtered`] = ret
                  });        
              }
            }
            // })
          }

          return input;
        });
      },

      inputsDetails() {
        if (this.readonlyComputed) return this.itemsDetails;

        return this.itemsDetails.length > 0
          ? this.tableItems.map(
              (item) =>
                this.itemsDetails.find((_item) =>
                  this.headersDetails
                    .filter((h) => h.identifier)
                    .every((h) => item[h.value] == _item[h.value])
                ) || item
            )
          : this.tableItems;
      },

      id() {
        return this.$route.params.id || this.item.id;
      },

      claimRoute() {
        return this.$route.meta.claimRoute;
      },

      computedHeaders() {
        var { companySelected } = this;
        return this.headersDetails.map(h => {
          const header = { ...h }

          if (header.set) {
            header.set = eval(header.set)
          }

          if (header.computeText) {
            header.text = eval(header.computeText)
          }

          if (header.computed) {
            header.computed = eval(header.computed)
          }
          
          if (header.editable) {
            header.editable = eval(header.editable)
          }
          
          if (header.validation && Array.isArray(header.validation)) {
            header.validation = header.validation.map(strFn => eval(strFn))
          }

          if (header.warning && Array.isArray(header.warning)) {
            header.warning = header.warning.map(strFn => eval(strFn))
          }

          if (header.hide && typeof header.hide == 'string') {
            header.hide = eval(header.hide)
          }
        
          return header
        })
      },

      computedDispatch() {
        return this.dispatch;
      },

      computedFilters() {
        return this.filtersDetails.map((filter) => {
          if (filter.filter) filter.filter = eval(filter.filter);
        });
      },

      computedCustomActions() {
        return this.customActions.map(action => action.data ? action.data : action)
      },

      filterItemsFunction() {
        const _default = _ => true
        try {
          const val = eval(this.filterItems)
          if (!val || !val.apply)
            return _default
          
          return val
        } catch(err) {
          return _default
        }
      },

      method() {
        return this.edit ? "edit" : "new";
      },

      jsPdfOutput() {
        if (this.jsPdf.doc)
          return this.jsPdf.doc.output('datauristring')
        else if (this.jsPdf.blob){
          // const base64 = await this.blobTo64({blob: this.jsPdf.blob}) 
          return URL.createObjectURL(this.jsPdf.blob)
        }
        else if (this.jsPdf.url) 
          return this.jsPdf.url

        return null
      },

      company() {
        // let companies = Object.keys(this.companies).map(c => this.companies[c]['sigamat'])
        // let sigamat = []
        // for (const company of companies) {
        //   sigamat.push(...company)
        // }
        // const filial = this.item.filial || this.item.FILIAL || ''
        // const gpEmpresa = this.item.gpEmpresa || this.item.GPEMPRESA || ''
        // return sigamat.find(c => c.id == `${gpEmpresa}${filial}`)
        return this.companySelected
      },


      computedClaims() {
        let claims = this.claims

        const isAdmin = this.user.superAdmin || this.user.companies[this.companySelected.groupCompany].admin

        claims.view = (claims.view && isAdmin) || this.userRules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.view)
        claims.add = (claims.add && isAdmin) || this.userRules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.add)
        claims.sync = (claims.sync && isAdmin) || this.userRules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.sync)
        claims.edit = (claims.edit && isAdmin) || this.userRules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.edit)
        claims.delete = (claims.delete && isAdmin) || this.userRules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.delete)
        claims.copy = (claims.copy && isAdmin) || this.userRules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.copy)

        return claims
      },

      computedExportPdf() {
        return (this.readonlyComputed || ['decanter','cermag', 'portao_cambui'].includes(this.companySelected.groupCompany)) && this.exportPdf
      },

      computedItemsBills() { return this.itemsBills },
      computedHeadersBills() { return this.bills.headers },
      computedDueDateField() { return this.bills.dueDateField },
      computedSA7off() { return this.SA7off },
    },

    methods: {
      ...mapActions(["dispatchAction"]),
      ...registersActions([
        "getExternal",
        "save",
        "saveOffline",
        "getById",
        "get",
        "getApi",
        "getGpEmpresa",
        "observer",
        "calculaImpostos",
        "base64Rascunho",
        "showToast", 
        'generatePDF'
      ]),
      ...mapMutations(["setLoading"]),
      ...registersMutations(["resetRegister"]),
      closeFab() {
        this.$refs['ionFab'].$el.close()
      },
      ultPedido() {
        this.$refs['formDetails'].ultPedido()
      },
      changeForm({ formData }) {
        if (this.tableIdFromValue !== formData[this.tableIdFrom]) {
          this.tableIdFromValue = formData[this.tableIdFrom]

          if (this.tableIdFromValue) {
            if (this.onDemand && !this.offline) {
              this.tableIdForeignValue = this.tableIdFromValue
            } else {
              this.getTableItems({collection: this.tableCollection, subCollection: this.tableSubcollection, orderSubcollection: this.orderSubcollection, id: this.tableIdFromValue})
            }
          } else {
            this.emptyResItems = true
            this.tableItems = []
          }
          this.itemFormMaster = formData
        }

        if (this.bills && this.bills.active && (this.fieldGetBillsValue !== formData[this.bills.fieldGetBills] || !this.fieldGetBillsValue)) {
          this.fieldGetBillsValue = formData[this.bills.fieldGetBills]
          if (this.fieldGetBillsValue) {
            this.setTableBills({item: formData})
          } else {
            this.itemsBills = []
          }
        }
        if (this.purchases && this.purchases.active && (this.fieldGetPurchasesValue !== formData[this.purchases.fieldGet] || !this.fieldGetPurchasesValue)) {
          this.fieldGetPurchasesValue = formData[this.purchases.fieldGet]
          if (this.fieldGetPurchasesValue) {
            this.setTablePurchases({item: formData})
          } else {
            this.itemsPurchases = []
          }
        }
        if (this.ordersByCustomer && this.ordersByCustomer.active && (this.fieldGetOrdersByCustomerValue !== formData[this.ordersByCustomer.fieldGet] || !this.fieldGetOrdersByCustomerValue)) {
          this.fieldGetOrdersByCustomerValue = formData[this.ordersByCustomer.fieldGet]
          if (this.fieldGetOrdersByCustomerValue) {
            this.setTableOrdersByCustomer({item: formData})
          } else {
            this.itemsOrdersByCustomer = []
          }
        }
      },

      customActionStyle(color){
        return {background: color}
      },

      getMaskedValue(header, value) {
        const prefix = header.prefix ? header.prefix + " " : "";

        const maskedValue =
          header.type == "float" || header.type == "integer"
            ? value.toLocaleString("pt-br", {
                minimumFractionDigits: header.precisionText,
                maximumFractionDigits: header.precisionText,
              })
            : value;

        const suffix = header.suffix ? " " + header.suffix : "";

        return prefix + maskedValue + suffix;
      },
      changeSegment(event) {
        console.log('event',event)
        this.segment = event.target.value;
      },
      async backButton() {
        store.$router.back();
      },
      showAction({ item, customAction }) {
        const showAction = eval(customAction.hide);
        return typeof showAction === "function"
          ? !showAction({ item })
          : !showAction;
      },

      clickAction({ item, customAction }) {
        const self = {
          item,
          $router: store.$router,
          user: this.user,
          $api: store.$api,
          ...this
        }
        const actionRunner = eval(customAction.actionRunner) //eval('async ({item, getApi, generatePdf, setLoading}) => { setLoading({stats: true, message: "Obtendo Danfe..."}); try { const {base64} = await getApi({url: "/protheus/", options: {params: {path: "Danfe64/" + item.C5_FILIAL + "/" + item.C5_NUM}}}); setLoading({stats: false}); if (base64){ generatePdf({base64str: base64}) }} catch (error) { setLoading({stats: false}); } };')
        actionRunner(self)
      },

      convertIcon(icon) {
        let iconIonic = icon
        switch (icon) {
          case 'mdi-newspaper-variant':
            iconIonic = newspaperOutline
            break;
        }

        return iconIonic
      },

      async submit({submitToErp = false, notBack = false, notToast, notLoading} = {}) {
        let response = false

        // MIGRADO PARA API
        // if (submitToErp && this.companySelected?.claims?.disableSubmitToErp) {
        //   this.showToast({ message: 'Integração ERP desativada. Entre em contato com administrador do sistema.', color: "warning" })
        //   return
        // }
      
        // Limpa filtros do table antes de enviar
        if (this.$refs['formDetails'] && this.$refs['formDetails'].dispatchClearFilters) { await this.$refs['formDetails'].dispatchClearFilters() }
     
        if (this.readonlyComputed) {
          // Não pode apenas redireciona, tem q voltar a rota para destriuir o componente, senão o inonic mistura as instancias do componente, mesmo tendo keys diferentes. 
          // this.goBack()
          if (!notBack) { store.$router.back() }
          return
        }

        if (await this.validate(submitToErp, notToast)) {
          try {
            response = await this.send(submitToErp, notToast, notLoading)
            this.setLoading({ stats: false });
            // Não pode apenas redireciona, tem q voltar a rota para destriuir o componente, senão o inonic mistura as instancias do componente, mesmo tendo keys diferentes. 
            // this.goBack()
            this.recorded = true
            if (!notBack) { store.$router.back() }
          } catch (err) {
            console.error(err)
            this.setLoading({ status: false});
          }
        }

        return response
      },

      async validate(submitToErp, notToast = false) {
        // Form Validation
        let validate = true;

        if (!this.$refs.formMaster.validate(submitToErp)) {
          if (!notToast) this.showToast({ message: 'Erro de Validação! Verifique os campos obrigatórios.', color: "error" })
          validate = false
        }
        
        if (validate && this.typeDetails == "data-table") {
          if (!this.$refs.formDetails) {
            // Ativa aba de items em caso de gravação sem abertura da aba
            await new Promise(resolve => setTimeout(() => {
              this.segment = 'items'
              resolve()
            }, 1));
          }

          const itemsDetails = this.$refs.formDetails.getModel()

          if (!itemsDetails.filter(this.filterItemsFunction).length > 0) {
            if (!notToast) this.showToast({ message: 'Itens não selecionados', color: "error" })
            validate = false
          } else if (itemsDetails.filter(i => i.invalidItem).length > 0) {
            if (!notToast) this.showToast({ message: 'Erro de Validação! Verifique os itens.', color: "error" })
            validate = false
          }

          if (typeof this.props.validation == 'function') {
            const item = this.$refs.formMaster.getModel();
            const totalize = this.$refs.formDetails?.getTotalize();
            
            const self = {
              item,
              itemsDetails,
              totalize,
              user: this.user,
              $router: store.$router,
              // $toast: this.$toast,
              $api: this.$api,
              get: this.get,
              getById: this.getById,
              getGpEmpresa: this.getGpEmpresa,
              getExternal: this.getExternal
            }
            const validation = await this.props.validation(self)
            if (!validation || typeof validation == 'string') { 
              if (!notToast) this.showToast({ message: `Erro de Validação: ${validation}`, color: "error" })
              validate = false
            }
          }
        }

        return validate
      },

      async calcImps(impostos) {
        this.setLoading({ stats: true, message: 'Calculando. Aguarde...' });
        if (!impostos) {
          this.impostosMessage = "Calculando...";
          this.impostos.itens = [];
          this.impostos.noData = this.impostos.noDataDefault;
          const item = this.$refs.formMaster.getModel();
          this.itemsDetails = this.$refs.formDetails.getModel()
          const itemsDetails = this.itemsDetails
            .filter(this.filterItemsFunction)
            .map((item) => ({ data: item }));
          if (!itemsDetails || !itemsDetails.length > 0)
            return (this.impostos.noData =
              "Não foi preenchido nenhum produto no pedido");
          this.impostos.loading = true;
          impostos = await this.calculaImpostos({
            item,
            itemsDetails,
            collectionDetails: this.collectionDetails,
          });
          if (impostos.response && impostos.response.status == 500)
            impostos = {
              Erros:
                (impostos.response &&
                  impostos.response.data &&
                  impostos.response.data.error) ||
                "Requisição cancelada, servidor Protheus offline.",
            };

          if (impostos.code == "ECONNABORTED")
            impostos = { Erros: "Requisição cancelada, tempo excedido." };
        }
        this.impostos.itens.push(impostos);
        this.impostos.headers = Object.entries(impostos)
          .sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0))
          .map((x) => ({ align: "center", text: x[0], value: x[0] }));
        this.impostos.noData = this.impostos.noDataDefault;
        this.impostos.loading = false;
        this.setLoading({ stats: false  });
      },

      async send(submitToErp, notToast = false, notLoading = false) {
        if (!notLoading) this.setLoading({ stats: true, message: 'Salvando. Aguarde...' });

        // item
        const item = this.$refs.formMaster.getModel();
        
        // impost
        if (
          this.impostos &&
          this.impostos.itens &&
          this.impostos.itens.length > 0
        ) {
          item.impostos = this.impostos.itens[0];
        }

        // itemsDetails
        let itemsDetails;
        if (this.typeDetails == "data-table") {
          itemsDetails = this.$refs.formDetails
            .getModel()
            .filter(this.filterItemsFunction)
            .map((item) => {
              delete item.show
              delete item.invalidItem
              delete item.invalidField
              return { data: item }
            });
        }

        // totalize
        const totalize = this.$refs.formDetails?.getTotalize()
        if (totalize && totalize.length > 0) {
          item._totalize = {}
          for (const total of totalize) {
            item._totalize[total.value] = total.original
          }
        }

        // Valida itens por garantia
        if (
          this.collectionDetails &&
          (!itemsDetails || !itemsDetails.length > 0)
        ) {
          this.$toast.error("Itens não informados.", { position: "top-right" });
          throw "Itens não informados.";
        }

        // adiciona id caso existe
        if (!(this.claimRoute === "add" && this.id)) {
          const id = this.id;
          if (!item.id && id) item.id = id;
        }
        if (this.autoSave.id) {
          const id = this.autoSave.id;
          if (!item.id && id) item.id = id;
        }

        // Dispatch Before
        if (this.computedDispatch.length > 0) {
          this.computedDispatch
            .filter((x) => x.when == "before" && x.method == this.method)
            .forEach((el) => {
              if (!el.switch || item[el.switch]) {
                this.dispatchAction({
                  action: el.action,
                  params: this.proccessParams({ params: el.params, item }),
                });
              }
            });
        }

        let response

        if (!submitToErp) item.status = 'Rascunho'
        const datePickers = this.computedInputsMaster.filter(input => input.type == 'date-picker')
        for (const input of datePickers) {
          if (item[input.value]) item[input.value] = item[input.value].substr(0, 10)
        }

        item.filialTenantId = this.companySelected.M0_CODFIL

        if (this.offline) {
          response = await this.saveOffline({
            integration: this.integration,
            collection: this.collection,
            collectionDetails: this.collectionDetails,
            item,
            itemsDetails,
            register: this.register
          })
        } else {
          response = await this.save({
            integration: this.integration,
            collection: this.collection,
            collectionDetails: this.collectionDetails,
            item,
            itemsDetails,
            submitToErp,
            notToast
          })
    
          // Dispatch After
          if (this.computedDispatch.length > 0) {
            this.computedDispatch
              .filter((x) => x.when == "after" && x.method == this.method)
              .forEach((el) => {
                if (!el.switch || item[el.switch]) {
                  this.dispatchAction({
                    action: el.action,
                    params: this.proccessParams({ params: el.params, item }),
                  });
                }
              });
          }
        }

        return response;
      },

      proccessParams({ item, params }) {
        const ret = {};
        for (const key in params) {
          if (Object.prototype.hasOwnProperty.call(params, key)) {
            const el = params[key];
            const pathItem = el.split(".");
            const lenItem = pathItem.length;
            if (lenItem == 1) {
              ret[key] = pathItem[0];
            } else {
              for (let ix = 1; ix < pathItem.length; ix++) {
                const el2 = pathItem[ix];
                if (typeof item[el2] != "undefined") {
                  ret[key] = item[el2];
                } else {
                  ret[key] = "";
                  break;
                }
              }
            }
          }
        }
        return ret;
      },

      goBack() {
        store.$router.push(`/tabs/${this.register}`);
      },

      goBonus() {
        store.$router.push(`/${this.register}/bonificar/${this.item.id}`);
      },

      handleItem(item) {
        return item;
      },

      async fetchDetails() {
        if (
          !this.collection ||
          !this.$route.params.id ||
          !this.collectionDetails
        ) {
          this.ready = true;
          return;
        }

        const collection = `customers/${this.companySelected.groupCompany}/${this.collection}`
        const ref = store.$db().collection(collection).doc(this.$route.params.id).collection(this.collectionDetails)
        const res = await this.get({collection, ref, limit: 1000})

        if (res) this.itemsDetails = res;

        if (this.itemsDetails.some(i => i.A7_YINCLUIR)) {
          this.SA7off = true
        }

        this.ready = true;
        return res;
      },

      initAutoSave() {
        if (this.readonly) return
        this.autoSave.timer = null;
        this.autoSave.timer = setInterval(async () => {
          const response = await this.submit({submitToErp: false, notBack: true, notToast: true, notLoading: false})
          if (response) {
            this.autoSave.id = response.data.data.id
            this.showToast({ 
              message: 'Salvamento automatico', 
              color: "success", 
              duration: 1000                
            })
          }
        }, 1000*10);
      },

      clearAutoSave() {
        clearInterval(this.autoSave.timer)
        this.autoSave.timer = false
      },

      /**
       * Transforma { a: { b: 1 } } em {'a.b': 1}
       * Ps: Funciona apenas para um nível de objeto
       * @TODO Generalizar para mais níveis
       * @TODO Funcionar com arrays.
       */
      normalizeItem(item) {
        Object.entries(item).forEach(([key, val]) => {
          if (typeof val == "object" && val) {
            Object.entries(val).forEach(([k, v]) => {
              if (typeof v == "object" && v) {
                Object.entries(v).forEach(([i, j]) => {
                  const newKey = key + "." + k + "." + i;
                  item[newKey] = j;
                });
              }
              const newKey = key + "." + k;
              item[newKey] = v;
            });
          }
        });
      },

      async filterSA7(value) {
        this.disableSA7 = !value
        const item = this.$refs?.formMaster?.getModel()
        if (!item) return
        await this.getTableItems({collection: this.tableCollection, subCollection: this.tableSubcollection, orderSubcollection: this.orderSubcollection, id: item[this.tableIdFrom]})
      },

      async getTableItems({ collection, id, subCollection, orderSubcollection }) {
        subCollection = subCollection
        const response = await this.getById({
          collection,
          id,
          subCollection,
          orderSubcollection: (this.offline) ? this.props?.orderSubcollectionOffline : orderSubcollection,
          filtersSubcollection: this.props?.filtersSubcollection,
          setRegister: false,
        });
        let subCollectionItems
        if(response && response[subCollection]){
          subCollectionItems = response[subCollection];
          delete response[subCollection];
        }

        if (!response || !subCollectionItems || !subCollectionItems.length > 0) {
          this.emptyResItems = true;
          return (this.tableItems = []);
        }

         if (subCollection == 'DA1') {
          // Removendo itens duplicados, deixando a data de vigencia ativa mais recente
          const now = store.$moment(new Date()).format("YYYYMMDD")
          const filteredByValidity = subCollectionItems
            // Filtra itens apenas dentro da vigencia
            .filter(x => x.DA1_DATVIG <= now)
            // Ordena itens pelo código e vigencia, DESC
            .sort((a, b) => {
              if (a.DA1_CODPRO+a.DA1_DATVIG > b.DA1_CODPRO+b.DA1_DATVIG) {return -1}
              else if (a.DA1_CODPRO+a.DA1_DATVIG < b.DA1_CODPRO+b.DA1_DATVIG) {return 1}
              else {return  0}
            })
            // Remove duplicados com base no código
            .filter((value, index, self) =>
              index === self.findIndex((t) => (
                t.DA1_CODPRO === value.DA1_CODPRO
              ))
            )
            // Retorna a ordenação padrão
            .sort((a, b) => {
              if (a[orderSubcollection] < b[orderSubcollection]) {return -1}
              else if (a[orderSubcollection] > b[orderSubcollection]) {return 1}
              else {return  0}
            })

          subCollectionItems = filteredByValidity
        }

        if (subCollection == 'DA1' && this.tableSA7) {
          // Verifica se existe amarração x cliente (SA7)
          const SA7 = await this.getSA7()
          const SA7Cod = SA7.map(x => x.A7_PRODUTO.trim())

          if (!this.disableSA7) { 
            subCollectionItems = subCollectionItems.filter(x => SA7Cod.includes(x.DA1_CODPRO.trim())).map(x => ({...x, ...SA7.find(y => y.A7_PRODUTO.trim() == x.DA1_CODPRO.trim()), A7_YINCLUIR:false}))
          } else {
            const itemsFilterFunction = this.$refs.formDetails?.getModel()?.filter(this.filterItemsFunction) || []
            subCollectionItems = subCollectionItems.map(x => {
              const y = itemsFilterFunction.find(z => z.C6_PRODUTO?.trim() === x.DA1_CODPRO.trim())
              if (y) {
                x = {...y,...x};
              }
              x.A7_YINCLUIR = true
              const ix = SA7.findIndex(y => y.A7_PRODUTO.trim() == x.DA1_CODPRO.trim())
              if (ix > -1) {
                x = {
                  ...x,
                  ...SA7[ix],
                  A7_YINCLUIR: false
                }
              }
              return x
            })
          }
        }

        this.tableItems = subCollectionItems.map((item) => {
          let filteredItem = {};
          this.headersDetails.forEach((header) => {
            filteredItem[header.value] =
              header.fill && item[header.fill]
                ? item[header.fill]
                : item[header.value];

            if (typeof filteredItem[header.value] === 'undefined' && header.value === 'B2_QATU') {
              filteredItem[header.value] = header.default; 
            }
          });
          return filteredItem;
        });
        this.emptyResItems = false
      },

      async getSA7() {
        const item = this.$refs.formMaster.getModel()
        if (item && item.SA1 && item.SA1.A1_COD) {
          return this.get({
            collection: 'SA7', 
            filters: [
              {key: "A7_CLIENTE", operator: '==', value: item.SA1.A1_COD},
              {key: "A7_LOJA", operator: '==', value: item.SA1.A1_LOJA},
            ], 
            limit: 9999,
            forceFilter: true,
            setRegister: false
          })
        } else {
          return []
        }
      },

      /**
       * Gera o pdf para ser exibido na tela e posteriormente baixado enviado por email
       */
      async blobTo64({ blob }) {
        return new Promise((resolve, _) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      },

      async generatePdf({base64str, objectStorage, url}) {
        if (!base64str && this.companySelected.groupCompany == 'decanter' && this.item.C5_NUM) {
          base64str = await this.pedidoDownload(this.item.C5_FILIAL +  '/' + this.item.C5_NUM)        
        } else if (!base64str && this.companySelected.groupCompany == 'decanter' && ( !this.item.status || this.item.status.trim() === 'Rascunho') ) {
          this.setLoading({stats: true})
          base64str = await this.imprimePedido()
        }

        if (!base64str && this.companySelected.groupCompany == 'samtronic' && this.item.CJ_NUM) {
          base64str = await this.orcamentoDownload(this.item.CJ_FILIAL +  '/' + this.item.CJ_NUM)        
        } else if(!base64str && this.companySelected.groupCompany == 'samtronic') {
          this.setLoading({stats: false})
          this.showToast({ message: 'Necessário enviar o orçamento para o Protheus antes de imprimir.', color: "warning" })
          return
        }
        
        this.setLoading({stats: true})

        if (url) this.jsPdf.url = url
        else if (objectStorage) {
          var xhr = new XMLHttpRequest();
          xhr.responseType = 'blob';
          
          xhr.onload = async (event) => {
            this.jsPdf.blob = xhr.response
            // this.jsPdf.doc = await this.blobTo64({blob: xhr.response})
            this.jsPdf.dialog = true
            this.setLoading({stats: false})
          };
          xhr.open('GET', objectStorage.documentUrl);
          xhr.send();
        }
        else if(base64str){
          // decode base64 string, remove space for IE compatibility
          var binary = atob(base64str.replace(/\s/g, ''));
          var len = binary.length;
          var buffer = new ArrayBuffer(len);
          var view = new Uint8Array(buffer);
          for (var i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i);
          }
          const doc = new jsPDF()
          var blob = new Blob( [view], { type: "application/pdf" });
          // const link = document.createElement('a')
          // link.href = URL.createObjectURL(blob)
          // link.click()
          

          // this.jsPdf.doc = blob
          // this.jsPdf.dialog = true
          this.jsPdf.blob = blob
          this.jsPdf.dialog = true
          this.savePdf({})
          this.setLoading({stats: false})
        } 
        else if (this.printLayout && this.printLayout.active && this.printLayout.link) {
          const header = this.$refs.formMaster.getModel()
          const itemsDetails = this.$refs.formDetails?.getModel()

          const items = ( !this.item.status || this.item.status.trim() === 'Rascunho') ? itemsDetails.filter(this.filterItemsFunction) : itemsDetails;
          
          if (this.props?.forceCalcImpPdf) { 
            this.setLoading({stats: true,  message: "Calculando imposto... Por favor aguarde."})
            await this.calcImps().catch(err => {
              this.$toast.error('Erro no calculo do imposto', {position: 'top-right'})
              this.setLoading({stats: false})
              throw err
            }).finally(() => this.setLoading({stats: false}))
            
            header.impostos = {itens: this.impostos.itens}  
          }

          this.setLoading({stats: true,  message: "Gerando PDF... Por favor aguarde."})

          const dataPrint = { 
            data: {            
              company: this.companySelected, 
              header, 
              items, 
              impostos: this.impostos,
              user: this.user
            }, 
            typeReturn: 'base64', 
            source: 'internal', 
            pathFileEJS: this.printLayout.link 
          }
          
          const { base64 } = await this.generatePDF({ dataPrint, register: this.collection })
          
          if ( base64 ) {
            const binary = atob(base64.replace(/\s/g, ''));
            const len = binary.length;
            const buffer = new ArrayBuffer(len);
            
            let view = new Uint8Array(buffer);
            for (let i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }
            
            const blob = new Blob( [view], { type: "application/pdf" });
            this.jsPdf.blob = blob
            this.jsPdf.dialog = true
          }

          this.savePdf({})
          this.setLoading({stats: false})
        }
        else {
          try {
            const doc = new jsPDF();
            const fontSize = 7
            let lineHeight = fontSize
            const fontFamily = "helvetica"
            const tableLineWidth = 0.2
            const tableLineColor = [125, 125, 125]
            const hexToNumber = str => eval('0x' + str)
            const fillColor = this.colorPdfTable && [
              hexToNumber(this.colorPdfTable.slice(1,3)),
              hexToNumber(this.colorPdfTable.slice(3,5)),
              hexToNumber(this.colorPdfTable.slice(5,7)),
            ] || [ 41, 128, 186] // azul padrão de header
      
            
            // altere o valor para determinar qual linha deve começar o documento
            let line = 2
      
            const size = {
              x: 210,
              y: 297 
            }
      
            const item = this.$refs.formMaster.getModel()
      
            /**
             * Logo
             * addImage ref: https://artskydj.github.io/jsPDF/docs/module-addImage.html
             */
            const image = (this.company?.configs?.logoPdf) ? await this.loadImage(this.company.configs.logoPdf) : await this.loadImage()
            doc.addImage(image, 'JPEG', 5, lineHeight, 16, 9)
      
            /**
             * Título
             */
            doc.setFont(fontFamily)
            doc.setFontSize(2.5 * fontSize)
            /** @TODO parametrizar o título */

            doc.text(eval(this.titleOfPrint || "'Impressão'"), size.x/2, line * lineHeight, { align: 'center' });
            doc.setFontSize(fontSize)
            line++
      
            /**
             * Empresa
             */
            const colsEmpresa = 3
            const company = this.company
            const empresaItems = this.printCompanyHeaders.map(pcH => {
              const valueCompiled = eval(pcH.value)
              return {...pcH, value: valueCompiled}
            })
            
            const empresaBody = []
            for (let row = 0; row < empresaItems.length / colsEmpresa; row++) {
              const rowInputs = empresaItems.slice(row*colsEmpresa, (row*colsEmpresa) + colsEmpresa)
              empresaBody.push(rowInputs.reduce((acc, item) => {
                const label = {
                  content: item.label,
                  styles: {
                    fillColor,
                    textColor: [255, 255, 255], 
                    fontStyle: 'bold',
                    lineWidth: 0.1,
                    lineColor: [171, 206, 228]
                  },
                }
                const value = {
                  content: item.value,
                }
      
                return [...acc, label, value]
              }, []))
            }

            empresaBody.push([{
              content: '',
              colSpan: 6,
              styles: {
                cellPadding: 3,
                lineWidth: { top: 0.1, left: 0, right: 0, bottom: 0.2 },
                lineColor: tableLineColor
              },
            }])
            
            // doc.autoTable({
            //   startY: line * lineHeight,
            //   body: empresaBody,
            //   margin: { top: 25, right: 5, bottom: 10, left: 5 },
            //   styles: { halign: 'center', fontSize, cellPadding: 1 },
            //   headStyles: { halign: 'center', fontStyle: 'bold' },
            //   tableLineWidth,
            //   tableLineColor,
            // })

            /**
             * Agrupar os inputMaster por quadrante de impressão
             */

            let inputMasterPerBox = []

            let inputsMaster = this.computedInputsMaster.filter(im => im.value && im.print && !im.returnObject)
            if (inputsMaster && !inputsMaster.length > 0) {
              inputsMaster = this.computedInputsMaster.filter(im => im.value && !im.returnObject)
            }
            
            // inputsMaster.forEach(im => {
            //   const imBox = inputMasterPerBox[im.print.box - 1] || []
            //   inputMasterPerBox[im.print.box - 1] = [...imBox, im]
            // })
            inputsMaster.forEach(im => {
              const box = (im.print && im.print.box) ? im.print.box : 1
              const imBox = (inputMasterPerBox && inputMasterPerBox.length > 0) ? inputMasterPerBox[box - 1] || [] : []
              inputMasterPerBox[box - 1] = [...imBox, im]
            })

            /**
             * Cabeçalho
             */
            // Define o número de colunas por tabela
            const cols = 3
            const body = [...empresaBody]
            
            inputMasterPerBox.forEach(imBox => {
              const inputs = (imBox && imBox.length > 0 && imBox[0].print && imBox[0].print.order) ? imBox.sort((a,b) => {
                if (a.print.order < b.print.order) {
                  return -1
                }
                if (a.print.order > b.print.order) {
                  return 1
                }
                return 0
              }) : imBox

              for (let row = 0; row < inputs.length / cols; row++) {
                const rowInputs = inputs.slice(row*cols, (row*cols) + cols)
                body.push(rowInputs.reduce((acc, input) => {
                  let text = item[input.value] || eval(`item.${input.value}`) || ''
                  if (input.type == 'select') {
                    const selectItem = input.items.find(i => i.value == item[input.value])
                    if (selectItem) 
                      text = selectItem.text || item[input.value]
                  } else if (input.type === 'switch') {
                    text = item[input.value] ? 'Sim' : 'Não'
                  }
        
                  /**
                   * Configuração do Label
                   * ref: https://github.com/simonbengtsson/jsPDF-AutoTable#options
                   */
                  const label = {
                    content: input.label,
                    styles: {
                      fillColor,
                      textColor: [255, 255, 255], 
                      fontStyle: 'bold',
                      lineWidth: 0.1,
                      lineColor: [171, 206, 228]
                    },
                  }
                  
                  /**
                   * Configuração do texto do valor do item
                   */

                  const value = typeof text === 'string' ? {content: text.trim()} : {content: text}
        
                  return [...acc, label, value]
                }, []))
              }
              doc.autoTable({
                // startY: doc.lastAutoTable.finalY + lineHeight,
                startY: line * lineHeight,
                body,
                margin: { top: 25, right: 5, bottom: 10, left: 5 },
                styles: {
                  fontSize,
                  cellPadding: 1,
                },
                tableLineWidth,
                tableLineColor,
              })
            })
            
            /**
             * Impostos
             */
            if (this.impostos && this.impostos.headers && this.impostos.headers.length > 0) {
              const head = [
                [{ content: 'Impostos', colSpan: this.impostos.headers.length, styles: { halign: 'center' }}],
                this.impostos.headers.map(el => ({content:el.text}))
              ]
              const impostosBody = [this.impostos.headers.map(el => {
                const value = this.impostos.itens[0][el.value]
                return `R$ ${value.toLocaleString('pt-br', { minimumFractionDigits:2, maximumFractionDigits: 2 }) }`
              })]
              doc.autoTable({
                startY: doc.lastAutoTable.finalY + lineHeight,
                head,
                body: impostosBody,
                margin: { top: 25, right: 5, bottom: 10, left: 5 },
                styles: { halign: 'center', fontSize, fillColor, cellPadding: 1 },
                headStyles: { halign: 'center', fontStyle: 'bold' },
                tableLineWidth,
                tableLineColor,
              })
      
              if (this.impostosPdfText)
                doc.text(this.impostosPdfText, 5, doc.lastAutoTable.finalY + (lineHeight/2))
            }
      
            /**
             * Totais
             */
            this.docPdfTotais(doc, { lineHeight, fontSize, fillColor, tableLineWidth, tableLineColor })
      
            /**
             * Tabela de itens
             */
            let headersItens = this.computedHeaders.filter(header => header.print)
            if (headersItens && !headersItens.length > 0) {
              headersItens = this.computedHeaders.filter(header => !header.noprint)
            } else {
              headersItens = headersItens.sort((h1, h2) => {
                if (h1.print.order < h2.print.order) {
                  return -1
                }

                if (h1.print.order > h2.print.order) {
                  return 1
                }

                return 0
              })
            }
          
            const head = [headersItens.map(h => h.text)]
            const headKeys = headersItens.map(h => h.value)

            const itemsTable = this.$refs.formDetails?.getTable()
          
            if(itemsTable && itemsTable.length > 0){
              const bodyTableItems = []
              for (const item of itemsTable) {
                if (!this.filterItemsFunction(item))
                  continue
                
                bodyTableItems.push(headKeys.map(header => typeof item[header] === 'string' ? item[header].trim() : item[header]))
              }

              // ref: https://github.com/simonbengtsson/jsPDF-AutoTable
              doc.autoTable({
                startY: doc.lastAutoTable.finalY + lineHeight,
                head,
                body: bodyTableItems,
                margin: { top: 25, right: 5, bottom: 10, left: 5 },
                styles: { fontSize, cellPadding: 1  },
                headStyles: { fontStyle: 'bold', fillColor, },
                tableLineWidth,
                tableLineColor,
              })
            }
      
            /**
             * Totais (fim da tabela)
             */
            this.docPdfTotais(doc, { lineHeight, fontSize, fillColor, tableLineWidth, tableLineColor })
      
            this.jsPdf.doc = doc
            this.jsPdf.dialog = true
            this.savePdf({item})
          } catch(e) {
            console.error(e)
          } finally {
            this.setLoading({stats: false})
          }
        }
      },

      async pedidoDownload(path) {      
        let retBase64 = ''

        this.setLoading({ stats: true, message: 'Obtendo pedido...' }); 
        try { 
            const { base64 } = await this.getApi({ url: '/protheus/', options: { params: { path: 'ufbase64/pedido/' + path } } }); 
            retBase64 = base64
            this.setLoading({ stats: false }); 
        } catch (error) { 
          this.setLoading({ stats: false }); 
        } 

        return retBase64
      },
      async imprimePedido() {
        // Limpa filtros do table antes de calcular
        if (this.$refs['formDetails'] && this.$refs['formDetails'].clearFilters) { await this.$refs['formDetails'].clearFilters() }

          const item = this.$refs.formMaster.getModel()
          const itemsDetails = this.$refs.formDetails.getModel().filter(this.filterItemsFunction).map(item => ({data: item}))
          if (!itemsDetails || !itemsDetails.length > 0) return this.printSketch.noData = 'Não foi preenchido nenhum produto no pedido'
          this.printSketch.loading = true
          let sketch64 = await this.base64Rascunho({
            item,
            itemsDetails,
            collectionDetails: this.collectionDetails,
          }).catch(err => {
            this.printSketch.loading = false
            throw err
          })
          if(sketch64.response && [0, 500].includes(sketch64.response.status)) {
            sketch64 = {Erros: sketch64.response?.data?.error || 'Requisição cancelada, servidor Protheus offline.'}
          }
          else if(sketch64.code == 'ECONNABORTED') { 
            sketch64 = {Erros: 'Requisição cancelada, tempo excedido.'}
          }
        
        
        this.printSketch.loading = false
        return sketch64.base64
      },
      async orcamentoDownload(path) {      
        let retBase64 = ''

        this.setLoading({ stats: true, message: 'Obtendo pedido...' }); 
        try { 
            const { base64 } = await this.getApi({ url: '/protheus/', options: { params: { path: 'ufbase64/orcamento/' + path } } }); 
            retBase64 = base64
            this.setLoading({ stats: false }); 
        } catch (error) { 
          this.setLoading({ stats: false }); 
        } 

        return retBase64
      },

      /**
       * Carrega a imagem da logo do osiris para por no PDF
       */
      async loadImage(logo) {
        const url = logo ?  require(`@/assets/${this.company.groupCompany}Logo.png`) : require('@/assets/logo.png')
        const response = await axios.get(url, { responseType: "blob" });
        const blob = response.data;
        return new Promise((resolve, reject) => {
          let fr = new FileReader();
          fr.onload = () => {
            resolve(fr.result);
          };
          fr.onerror = reject;
          fr.readAsDataURL(blob);
        });
      },

      docPdfTotais(
        doc,
        { lineHeight, fontSize, fillColor, tableLineWidth, tableLineColor }
      ) {
        const headers = this.computedHeaders.filter((header) => {
          if ("exportPdf" in header)
            return header.exportPdf === true || header.exportPdf == "totais";
          else return true;
        });
        
        const totalize = this.$refs.formDetails
          .getTotalize()
          .filter((el) => !!headers.find((h) => h.value == el.value));
        if (totalize) {
          const head = [
            [
              {
                content: "Totais",
                colSpan: totalize.length,
                styles: { halign: "center" },
              },
            ],
            totalize.map((el) => el.label),
          ];
          const body = [totalize.map((el) => el.text)];
          doc.autoTable({
            startY: doc.lastAutoTable.finalY + lineHeight,
            head,
            body,
            margin: { top: 25, right: 5, bottom: 10, left: 5 },
            styles: { halign: "center", fontSize, fillColor, cellPadding: 1 },
            headStyles: { halign: "center", fontStyle: "bold" },
            tableLineWidth,
            tableLineColor,
          });

          if (this.totaisPdfText)
            doc.text(
              this.totaisPdfText,
              5,
              doc.lastAutoTable.finalY + lineHeight / 2
            );
        }
      },

      /** @TODO parametrizar o nome do documento */
      savePdf({item}) {
        if (this.jsPdf.doc) this.jsPdf.doc.save(`${eval(this.titleOfPrint)}.pdf`);
        else if (this.jsPdf.blob) {
          fs.saveAs(this.jsPdf.blob, "Arquivo -" + new Date().valueOf() + ".pdf");
        }

        // console.warn("jsPdf.doc not yet defined.");
      },

      async sendPdf({ to, text, bcc, cc, subject }) {
        let response;
        try {
          this.jsPdf.sendEmail.sending = true;
          if (this.jsPdf.doc) {
            response = await this.$api.post(`/mail`, {
              to,
              text,
              id: this.id,
              bcc,
              cc,
              subject,
              attachment: this.jsPdfOutput,
            });

            this.jsPdf.sendEmail.dialog = false;
            this.$toast.success("Email enviado!", { position: "top-right" });
          } else if (this.jsPdf.blob) {
            let reader = new FileReader();
            reader.readAsDataURL(this.jsPdf.blob);
            reader.onloadend = async () => {
              let base64data = reader.result;
              response = await this.$api.post(`/mail`, {
                to,
                text,
                id: this.id,
                bcc,
                cc,
                subject,
                attachment: base64data,
              });

              this.jsPdf.sendEmail.dialog = false;
              this.$toast.success("Email enviado!", { position: "top-right" });
            };
          }
        } catch (err) {
          response = err;
        } finally {
          this.jsPdf.sendEmail.sending = false;
        }

        return response;
      },

      jsPdfHandleDialog(value) {
        if (value) {
          const item = this.$refs.formMaster.getModel();

          const integration = this.$integrations.find(
            (i) => i.collection === this.collection
          );
          const {
            toDefault,
            subjectDefault,
            textDefault,
            enableCcDefault: enableCc,
            ccDefault,
            enableBccDefault: enableBcc,
            bccDefault,
          } = (integration && integration.emailConfigs) || {
            toDefault: '""',
            textDefault: '""',
            subjectDefault: '""',
            enableCcDefault: false,
            ccDefault: '""',
            enableBccDefault: false,
            bccDefault: '""',
          };

          const to = eval(toDefault);
          const text = eval(textDefault);
          const subject = eval(subjectDefault);
          const cc = eval(ccDefault);
          const bcc = eval(bccDefault);

          /** @TODO parametrizar */
          // const to = item['SA1'] && item['SA1']['A1_EMAILPDF'] && item['SA1']['A1_EMAILPDF'].trim() || ''
          this.jsPdf.sendEmail.model = {
            to,
            text,
            subject,
            cc,
            bcc,
          };

          this.jsPdf.sendEmail.inputs = this.jsPdf.sendEmail.inputs.map((i) => {
            if (i.value === "cc") return { ...i, hide: !enableCc };
            else if (i.value === "bcc") return { ...i, hide: !enableBcc };
            return i;
          });
        } else {
          this.jsPDF.sendEmail.model = null;
        }
      },

      async setTableBills({item}) {
        let filters = ``

        if (this.bills.filters) {
          if (this.bills.filters.includes('=>')) {
            const filtersComputed = eval(this.bills.filters)
            filters = filtersComputed(item)
          } else if (this.bills.filters.includes('`'))  {
            filters = eval(this.bills.filters)
          } else {
            filters = this.bills.filters
          }
        }

        this.getExternal({
          setRegister: false,
          allRegs: true,
          ordem: this.bills.order,
          idField: this.bills.idField,
          query: this.bills.query,
          filters,
          params: this.item,
          register: `${this.register}.bills`
        }).then(res => {
          if (Array.isArray(res)) {
            this.itemsBills = res
          } else {
            this.itemsBills = []
          }
         
          this.dueDateExists = (this.itemsBills) ? this.itemsBills.some(i => {
            const today = store.$moment(new Date(), 'YYYYMMDD')
            return today.format('YYYYMMDD').trim() > i[this.computedDueDateField].trim()
          }) : false
        }).catch(err => this.itemsBills = [])
      },

      async setTablePurchases({item}) {
        let filters = ``
    
        if (this.purchases.filters) {
          if (this.purchases.filters.includes('=>')) {
            const filtersComputed = eval(this.purchases.filters)
            filters = filtersComputed(item)
          } else if (this.purchases.filters.includes('`'))  {
            filters = eval(this.purchases.filters)
          } else {
            filters = this.purchases.filters
          }
        }

        this.getExternal({
          setRegister: false,
          allRegs: true,
          ordem: this.purchases.order,
          idField: this.purchases.idField,
          query: this.purchases.query,
          params: item,
          filters,
          register: `${this.register}.purchases`
        }).then(res => {
          if (Array.isArray(res)) {
            this.itemsPurchases = res
          } else {
            this.itemsPurchases = []
          }
        }).catch(err => this.itemsPurchases = [])
      },

      async setTableOrdersByCustomer({item}) {
        let filters = ``

        if (this.ordersByCustomer.filters) {
          if (this.ordersByCustomer.filters.includes('=>')) {
            const filtersComputed = eval(this.ordersByCustomer.filters)
            filters = filtersComputed(item)
          } else if (this.ordersByCustomer.filters.includes('`'))  {
            filters = eval(this.ordersByCustomer.filters)
          } else {
            filters = this.ordersByCustomer.filters
          }
        }

        this.getExternal({
          setRegister: false,
          allRegs: true,
          ordem: this.ordersByCustomer.order,
          idField: this.ordersByCustomer.idField,
          query: this.ordersByCustomer.query,
          params: item,
          filters,
          register: `${this.register}.ordersByCustomer`
        }).then(res => {
          if (Array.isArray(res)) {
            this.itemsOrdersByCustomer = res
          } else {
            this.itemsOrdersByCustomer = []
          }
        }).catch(err => this.itemsOrdersByCustomer = [])
      },

      resetRegister() {
        this.keyRegister = Math.random()
        this.tableIdForeignValue = null
        this.totalize = null
      }
      
    },

    async ionViewWillEnter() {
      if (this.companySelected?.claims?.autosave?.active) {
        this.initAutoSave()
      }
      this.resetRegister()
      
      // Reset Segment
      this.segment = 'data'
    
      // if (this.collection && (this.collection.includes('SC5') || this.collection.includes('SA1'))) {
        /**
         * Begin TO-DO
         * Retirar esse código e ver como usar em um filtro ou validação
         * na integrations
         */
        // let filtersSE4 = [{ key: "active", operator: "==", value: true }];

        // se for bonificação ou cópia, só traga a 999
        // if (
        //   (!this.id && this.claimRoute === "add") ||
        //   (this.claimRoute === "edit" &&
        //     this.collection === "SC5" &&
        //     this.item.C5_XTIPO !== "B")
        // ) {
        //   this.resetRegister("SE4");
        //   filtersSE4.push({ key: "E4_CODIGO", operator: "!=", value: "999" });
        // }
        // else
        //   filtersSE4.push({key: 'E4_CODIGO', operator: '!=', value: '999'})

        /**
         * End TO-DO
         */
      // }

      if (this.id) {
        let handleItem = false;
        let item =
          this.registers[this.register] &&
          this.registers[this.register].find(
            (item) => item.id === this.$route.params.id
          );
        if (!item)
          item = await this.getById({
            collection: this.collection,
            register: this.register,
            id: this.$route.params.id,
            getFilial: false,
          });
        else this.normalizeItem(item);

        /**
         * TO-DO
         * Tire isso daqui
         */
        if (this.claimRoute === "add") {
          const {
            C5_CLIENTE,
            C5_LOJACLI,
            SA1,
            A1_NOME,
            A1_END,
            A1_EST,
            A1_MUN,
            A4_NREDUZ,
            C5_FILIAL,
            DA0,
            C5_TABELA,
            SA4,
            C5_TRANSP,
            DA0_DESCRI,
            C5_NUM,
            C5_TPFRETE,
          } = item;
          this.item = {
            C5_CLIENTE,
            C5_LOJACLI,
            SA1,
            A1_NOME,
            A1_END,
            A1_EST,
            A1_MUN,
            A4_NREDUZ,
            C5_FILIAL,
            DA0,
            C5_TABELA,
            C5_TPFRETE,
            E4Blocked: true,
            DA0_DESCRI,
            SA4,
            C5_TRANSP,
            C5_XTIPO: "B",
            C5_XPEDORI: C5_NUM,
          };

          /**
           * TO-DO
           * Tirar essa gambiarra daqui depois. Ver essa lógica para colocar na computed
           */
          // setTimeout(()=>{
          //   const SE4 = this.registers.SE4.find(condPG => condPG.E4_CODIGO.trim() === '999')
          //   this.item = {...this.item, SE4}
          // },1500)
        } else this.item = handleItem ? this.handleItem(item) : item;

        // se for criação, não puxe os impostos, pois é uma cópia
        if (
          this.claimRoute !== "add" &&
          (item.impostos || item.IMPOSTOS || item.Impostos)
        )
          this.calcImps(item.impostos || item.IMPOSTOS || item.Impostos);

        if (this.claimRoute !== "add") {
          await this.fetchDetails();
        }

        if (item[this.tableIdFrom] /*&& !this.readonlyComputed*/){
          if (this.onDemand && !this.offline) {
            this.tableIdForeignValue = item[this.tableIdFrom]
          } else {
            await this.getTableItems({
              collection: this.tableCollection,
              subCollection: this.tableSubcollection,
              orderSubcollection: this.orderSubcollection,
              id: item[this.tableIdFrom],
            });
          }
        }

        if (this.bills && this.bills.active) {
          // this.itemFormMaster = this.$refs.formMaster.getModel() 
          await this.setTableBills({item: this.$refs.formMaster.getModel()})
        }
        if (this.purchases && this.purchases.active) {
          // this.itemFormMaster = this.$refs.formMaster.getModel() 
          await this.setTablePurchases({item: this.$refs.formMaster.getModel()})
        }

        if (this.ordersByCustomer && this.ordersByCustomer.active) {
          // this.itemFormMaster = this.$refs.formMaster.getModel() 
          await this.setTableOrdersByCustomer({item: this.$refs.formMaster.getModel()})
        }

        this.tableIdFromValue = item[this.tableIdFrom]
        if(this.bills && this.bills.fieldGetBills) this.fieldGetBillsValue = item[this.bills.fieldGetBills]
        if(this.purchases && this.purchases.fieldGet) this.fieldGetPurchasesValue = item[this.purchases.fieldGet]
        if(this.ordersByCustomer && this.ordersByCustomer.fieldGet) this.fieldGetOrdersByCustomerValue = item[this.ordersByCustomer.fieldGet]
      } else {
        this.ready = true;
      }
    },

    async beforeRouteLeave(to, from) {
      if (this.props.ionBackButtonSave && !this.readonlyComputed && !this.leave && !this.recorded) {
          const response = await this.submit({submitToErp: false, notBack: true})
          this.leave = true
          if (!response) {
            this.showToast({ 
              message: 'Pedido não gravado! Deseja Sair?', 
              color: "warning", 
              duration: 4000,
              buttons: [
                {
                  text: 'Sair',
                  role: 'cancel',
                  handler: () => {
                    this.clearAutoSave()
                    store.$router.back();
                  },
                }
              ]
            })
            return false
          }
      }
      this.clearAutoSave()
    },

    created() {
      const status = this.inputsMaster.find((x) => x.value === "status")
      const statusAlt = this.inputsMaster.find((x) => x.value === "status2")

      try{
        if(statusAlt){
          statusAlt.list = typeof statusAlt.list == 'string' ? eval(statusAlt.list) || false : statusAlt.list
          if(typeof statusAlt.list == 'function'){
            if (statusAlt.list({user: this.user})){
              statusAlt.hide = false
              if (status){
                status.hide = true
              }
            } else {
              statusAlt.hide = true
              if (status){
                status.hide = false
              }
            }
          }
        }
      } catch (e){
        if (statusAlt)
          statusAlt.hide = true
        if (status)
          status.hide = false
        console.log(e)
      }
    },
  };
</script>

<style>
  .card-taxes ion-card-header {
    padding: .25em;
  }
  .card-errors ion-card-header {
    padding: 0;
    text-align: center;
  }
  .card-errors ion-card-header ion-button {
    margin: 0;
  }
  .due-date-exists {
    --color: var(--ion-color-danger);
    --color-checked: var(--ion-color-danger);
  }
  .due-date-not-exists {
    --color: var(--ion-color-warning);
    --color-checked: var(--ion-color-warning);
  }
</style>